import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { PillSuggestion, SuggestionKind } from 'owa-search-service';

/**
 * Helper function to determine if given suggestion pill already exists in the
 * search box.
 * @param suggestionPill Suggestion pill to compare against suggestions in store
 */
export default function isSuggestionPillInSearchBox(
    suggestionPill: PillSuggestion,
    scenarioId: SearchScenarioId
): boolean {
    const store = getScenarioStore(scenarioId);

    switch (suggestionPill.kind) {
        /**
         * For persona pills, verify there is no overlap of email addresses between
         * the pill that is trying to be added with any email addresses of suggestions
         * that are already in the store.
         */
        case SuggestionKind.People: {
            return (
                [...store.suggestionPills.values()].filter(
                    (suggestionPillInStore: PillSuggestion) => {
                        if (suggestionPillInStore.kind !== SuggestionKind.People) {
                            return false;
                        }

                        for (const selectedSuggestionEmail of suggestionPill.EmailAddresses) {
                            for (const storeSuggestionEmail of suggestionPillInStore.EmailAddresses) {
                                if (selectedSuggestionEmail === storeSuggestionEmail) {
                                    return true;
                                }
                            }
                        }

                        return false;
                    }
                ).length > 0
            );
        }
        /**
         * For category pills, verify that there is no other suggestion with the
         * same ReferenceId already in the store.
         */
        case SuggestionKind.Category: {
            return store.suggestionPillIds.indexOf(suggestionPill.ReferenceId) > -1;
        }
        default:
            return false;
    }
}
